// extracted by mini-css-extract-plugin
export default {"toggle-resource-btns-wrapper":"ToggleResources_toggle-resource-btns-wrapper__bdphG","toggle-resource-btn":"ToggleResources_toggle-resource-btn__gE3DM"};